<template>
	<div class="crud-wrapper">
		<crud :form-component="PendingAppUsersForm" :grid-columns="gridColumns" :grid-options="gridOptions" :gridSettings="{noNew: true}" obj="pendingAppUser" ref="crud">
		</crud>
	</div>
</template>
<script>
import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
import PendingAppUsersForm from './PendingAppUsersForm'
import gql from 'graphql-tag'

const GET_PENDING_APP_USERS_SUBS = gql`
subscription subsGetPendingAppUsers {
  _person(where: {person_type: {_eq: "A"}, removed_at: {_is_null: true}, person_customer: {customer_jobs: {id: {_is_null: false}, covenant: {id: {_is_null: false}}}, status: {_eq: "B"}}}) {
    id
    name
    person_customer {
      id
      status
      customer_jobs {
        id
        covenant {
          id
        }
      }
      customer_docs(order_by: {created_at: asc}, limit: 1) {
        id
      }
    }
  }
}`

export default PageClass.extend({
	name: 'PendingAppUsers',
	data() {
		return {
			PendingAppUsersForm,

			// brandId: null,
			crudGrid: null,

			gridColumns: [
				{
					dataField: 'covenantName',
					caption: 'Convênio',
					minWidth: 150
				},
				{
					dataField: 'federalId',
					caption: 'CPF',
					format: function (value) {
						value = value.replace(/[^\d]/g, "");
						return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
					},
					minWidth: 150
				},
				{
					dataField: 'name',
					caption: 'Nome',
					minWidth: 150
				},
				{
					dataField: 'enrollment',
					caption: 'Matrícula/NB',
					minWidth: 150
				},
				{
					dataField: 'birth',
					format: (value) => {
						return this.$moment(value).format('DD/MM/YYYY');
					},
					dataType: 'datetime',
					caption: 'Nascimento',
					minWidth: 150
				},
				{
					dataField: 'city',
					caption: 'Cidade',
					minWidth: 150
				},
				{
					dataField: 'state',
					caption: 'Estado',
					minWidth: 150
				},
				{
					dataField: 'status',
					caption: 'Status',
					customizeText: function (data) {
						switch (data.valueText) {
							case 'B':
								data.valueText = 'Novo'
								break;
							case 'P':
								data.valueText = 'Pendente';
								break;
							case 'R':
								data.valueText = 'Rejeitado';
								break;
							case 'V':
								data.valueText = 'Validado';
								break;
						}
						return data.valueText;
					},
					alignment: 'center',
					minWidth: 150
				},
				{
					dataField: 'firstDocumentAt',
					caption: 'Documentos anexados',
					customizeText: (data) => {
						if (data && data.value)
							return 'Sim';
						else
							return "Não"
					},
					alignment: 'center',
					minWidth: 150
				},
				{
					dataField: 'firstDocumentAt',
					caption: 'Cadastrado',
					customizeText: (data) => {
						if (data && data.value)
							return this.$moment(data.value).fromNow();
						else
							return "Não cadastrado"
					},
					alignment: 'center',
					minWidth: 150
				},
				{
					dataField: 'suspicious',
					caption: 'Suspeito',
					customizeText: (data) => {
						if (data && data.value)
							return 'Sim';
						else
							return "Não"
					},
					alignment: 'center',
					minWidth: 150
				}
			],

			gridOptions: {

			}
		}
	},
	mounted() {
		this.crudGrid = this.$refs.crud.$refs.crudGrid;

	},
	created() {
		this.$apollo.subscribe({
			query: GET_PENDING_APP_USERS_SUBS
		}).subscribe((data) => {
			if (this.crudGrid) {
				this.crudGrid.refresh();
			}
		});
	}

})
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/PendingAppUsers.vue